import service from "@/api";
import request from "@/utils/request";

const proj = process.env.VUE_APP_PROJ;

// 获取用户登录凭证token
export const getAuthorizeInfo = (params) => {
  params = params || {};
  params.tenantId = global.APP_CONFIG.tenantId;
  if (proj === "audi") {
    return service.get("/wxapi/auth/v1/app/authorize", {
      headers: { noSuccToast: false },
      params,
    });
  }
  return service.get("/dapi/auth/v1/app/authorize", {
    headers: { noSuccToast: false },
    params,
  });
};

// 获取当前用户信息
export const getUsersCurrentInfo = async (params) => {
  if (proj === "audi") {
    return service.get("/wxapi/auth/v1/app/user", {
      headers: { noSuccToast: true },
    });
  }
  return service.get("/wxapi/auth/v1/app/authorize", {
    headers: { noSuccToast: false },
    params,
  });
};

//  获取JSAPI签名信息
export const getJssdkConfig = (params) => {
  params = params || {};
  params.tenantId = global.APP_CONFIG.tenantId;
  params.appId = global.APP_CONFIG.appId;
  if (self !== top) {
    return;
  }
  if (proj === "audi") {
    return service.post(
      "/wxapi/qw-proxy-gateway/v1/ticket/app/web/jsapi-sign",
      params,
      { headers: { noSuccToast: true } }
    );
  }
  return request({
    url: "/dapi/qw-proxy-gateway/wxwork/v1/ticket/app/web/jsapi-sign",
    method: "post",
    data: params,
  });
};

/**
 * 通过code获取当前用户信息 企微
 */
export function getUsersInfoByCode(data) {
  return request({
    url: "/dapi/qw-proxy-gateway/wxwork/v1/user/getByCode",
    method: "post",
    data,
  });
}

/**
 * 测试 微信通过code获取AccessToken与openid
 */
export function getAccessTokenByCodeApi(data) {
  return request({
    url: `/dapi/wechat/api/cnvlw/wechatpush/wx/wechat-push/api/v1/oauth/getAccessToken2?code=${data.code}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "scrm-h5",
      "Application-Id": "6b3e59bf-95cf-4937-af4c-6fd5e90f7d4c",
    },
    data: {},
  });
}

/**
 * 生产 微信通过code获取AccessToken与openid
 */
export function getAccessTokenApi(data) {
  return request({
    url: `/dapi/wechat/api/cnvlw/wechatpush/wx/wechat-push/api/v1/oauth/getAccessToken2?code=${data.code}`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: "scrm-h5",
      "Application-Id": "c7337b28-d97e-499a-98a5-416e69557552",
    },
    data: {},
  });
}

/**
 * 获取用户上级部门
 */
export function getSuperiorDeptApi(params) {
  return request({
    url: "/dapi/qw-proxy-gateway/wxwork/v1/depts/getSuperiorDept",
    method: "get",
    params,
  });
}
